import { render, staticRenderFns } from "./ShippingList.vue?vue&type=template&id=eee8b424"
import script from "./ShippingList.vue?vue&type=script&lang=js"
export * from "./ShippingList.vue?vue&type=script&lang=js"
import style0 from "./ShippingList.vue?vue&type=style&index=0&id=eee8b424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports